import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import React, { useState } from "react";
import { Link } from "react-router-dom";

// Material Icon
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";

export default function TransactionTable({data}) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - data.length) : 0;

  return (
    <Paper sx={{ width: "100%", overflow: "hidden", boxShadow: "none" }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: "800" }}>No</TableCell>
              <TableCell sx={{ fontWeight: "800" }}>Name</TableCell>
              <TableCell sx={{ fontWeight: "800" }}>Transaction Hash</TableCell>
              <TableCell sx={{ fontWeight: "800" }}>Buyer</TableCell>
              <TableCell sx={{ fontWeight: "800" }}>Tanggal Beli</TableCell>
              <TableCell sx={{ fontWeight: "800" }}>Total Harga</TableCell>
              <TableCell sx={{ fontWeight: "800" }} align="right">
                Amount
              </TableCell>
              <TableCell sx={{ fontWeight: "800" }} align="right">
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0
              ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              : data
            ).map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.id + 1}</TableCell>
                <TableCell>{row.nft.resi.name}</TableCell>
                <TableCell>{row.txhash}</TableCell>
                <TableCell>{row.user.name}</TableCell>
                <TableCell>{(new Date(row.createdAt)).toLocaleDateString()}</TableCell>
                <TableCell>{"Rp. " + row.totalPrice.toLocaleString()}</TableCell>
                <TableCell align="right">{row.nftAmount}</TableCell>
                <TableCell align="right">
                  <Stack
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="center"
                    spacing={1}
                  >
                    <IconButton component={Link} to="/transaction-list/view">
                      <RemoveRedEyeOutlinedIcon />
                    </IconButton>
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
            {emptyRows > 0 && (
              <TableRow style={{ height: 53 * emptyRows }}>
                <TableCell colSpan={6} />
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
